/**
 * Resolves a promise after reading a `File` to a data URL.
 */
export const readFile = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.addEventListener(
      'load',
      () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result);
        } else {
          reject(new Error('Not able to read file to data url'));
        }
      },
      false,
    );

    reader.addEventListener('error', (error) => reject(error));

    reader.readAsDataURL(file);
  });
};
